import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Modal } from "react-bootstrap";
import { getAccount } from "Redux/Actions/GetAccountAction";
import * as ROUTES from "Constants/Routes";
import STRINGS from "Constants/Strings";
import AppConstants from "Constants/AppConstants";
import MODALMESSAGES from "Constants/Messages";
import { callCreateInverite } from "Components/Inverite/Actions/InveriteAction";
import {
  getProductFromVault,
  updateProductToVault,
} from "Components/MarketPlace/Action/MarketPlaceAction";
import { getApplicationList } from "Redux/Actions/ApplicationAction";
import withApplicantHOC from "Hoc/ApplicantHOC/ApplicantHOC";
import {
  createEsignDoc,
  sendEsignPackage,
  getEsign,
} from "./Actions/SignatureAction";
import Signature from "./Signature";
import { getApplicationProperty } from "../JointApplicant/Actions/JointApplicantAction";
import {
  S_BANKING_TYPE_SWITCH,
  S_EMAIL,
  S_STAFF_EMAIL,
} from "../../Communication/Constants";
import { isInBranchFlow } from "../../Utils/LogicUtilities";
import {
  addDocument,
  deleteDocument,
  getDocumentList,
} from "../Documents/Actions/DocumentAction";

class SignatureContainer extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      choice: "",
      showPage1: true,
      showPage2: false,
      showPage3: false,
      showModal: false, // default state for popup modal
      modalType: "", // popup modal type (success or error)
      modal: {
        title: "", // popup modal title
        description: "", // popup modal description
      },
      signatureCompleted: false,
      activeProduct: {},
      showSmartBranchModal: false,
      includeESignaturePackage: false,
    };
  }

  componentDidMount() {
    console.log("componentDidMount");
    const {
      products,
      getActiveProduct,
      continuehandler,
      history,
      doGetApplicationList,
      doCreateEsignDoc,
      doGetEsign,
      doGetApplicationProperty,
      inReview,
      uploadedAt,
    } = this.props;

    const activeProduct = getActiveProduct(products);
    this.setState({
      activeProduct,
    });

    if (!activeProduct) {
      history.push(ROUTES.VAULT_DASHBOARD);
    } else if (inReview || uploadedAt) {
      continuehandler("", AppConstants.APPLICATIONSTEP.SIGNATURE);
    } else {
      doGetApplicationProperty(
        { applicationId: activeProduct.applicationId },
        (currentApplication) => {
          console.log("current", currentApplication);
          const slotsApplied = currentApplication.slots.filter(
            (slot) => slot.appliedAt
          );
          if (currentApplication.inReview || currentApplication.uploadedAt) {
            continuehandler("", AppConstants.APPLICATIONSTEP.SIGNATURE);
          } else if (
            !currentApplication.appliedAt &&
            currentApplication.slots.length != slotsApplied.length
          ) {
            history.push(ROUTES.CONFIRM_ACCOUNT_CREATE);
          } else if (currentApplication.esignPackageSentAt) {
            this.setState({
              showPage1: false,
              showPage2: true,
              showPage3: false,
            });
            activeProduct.contract.forEach((contract) => {
              console.log("contract", contract);
              const signer = contract.signers.find(
                (contractSigner) =>
                  contractSigner.applicantId === activeProduct.applicantId
              );
              if (signer) {
                console.log("opening tab", signer.url);
                setTimeout(() => {
                  const a = document.createElement("a");
                  a.setAttribute("href", signer.url);
                  a.setAttribute("target", "_blank");
                  a.click();
                }, 5000);
              }
            });
          } else if (currentApplication.esignDocStartAt) {
            this.setState({
              showPage1: true,
              showPage2: false,
              showPage3: false,
            });
          } else {
            doCreateEsignDoc(activeProduct.applicationId, (createResponse) => {
              console.log(createResponse);
              this.setState({
                showPage1: true,
                showPage2: false,
                showPage3: false,
              });
            });
          }
        }
      );
    }
  }

  toggleModal = () => {};

  showModal = () => {
    this.setState({});
  };

  handlePopupModalBtnClick = () => {
    const { signatureCompleted } = this.state;
    const { continuehandler } = this.props;
    if (signatureCompleted) {
      continuehandler({}, AppConstants.APPLICATIONSTEP.SIGNATURE);
    }
  };

  handleSmartBranchCheckboxChange = (event) => {
    this.setState({
      includeESignaturePackage: event.target.checked,
    });
  };

  handleSmartBranchContinue = () => {
    const { includeESignaturePackage } = this.state;
    const { doGetEsign, getActiveProduct, products } = this.props;
    console.log("handleSmartBranchContinue", includeESignaturePackage);

    const activeProduct = getActiveProduct(products);
    this.setState({ showSmartBranchModal: false }, () => {
      doGetEsign(
        {
          applicationId: activeProduct.applicationId,
          sendToStaffEmail: includeESignaturePackage
            ? sessionStorage.getItem(S_STAFF_EMAIL)
            : null,
        },
        () => {
          this.setState({
            showPage1: false,
            showPage2: true,
            showPage3: false,
          });
        }
      );
    });
  };

  handleSmartBranchClose = () => {
    const { continuehandler } = this.props;
    this.setState(
      { showSmartBranchModal: false },
      continuehandler("", AppConstants.APPLICATIONSTEP.SIGNATURE)
    );
  };

  goToPage2 = () => {
    console.log("goToPage2");
    this.setState({
      showPage1: false,
      showPage2: true,
      showPage3: false,
    });
  };

  handleContinue = (choice, options = {}, documentList) => {
    const {
      continuehandler,
      doCreateEsignDoc,
      products,
      getActiveProduct,
      doSendEsignPackage,
      doGetEsign,
      history,
      doUpdateProductToVault,
      applicantData,
      doGetApplicationProperty,
    } = this.props;
    const {
      showPage1,
      showPage2,
      showPage3,
      includeESignaturePackage,
    } = this.state;
    const dispatchObject = {
      agree: choice,
    };
    console.log("handleContinue", choice, options);
    const activeProduct = getActiveProduct(products);
    const bankingTypeSwitch = sessionStorage.getItem(S_BANKING_TYPE_SWITCH);

    doGetApplicationProperty(
      { applicationId: activeProduct.applicationId },
      (currentApplication) => {
        console.log("current", currentApplication);
        if (currentApplication.inReview) {
          continuehandler(
            { showInReview: true },
            AppConstants.APPLICATIONSTEP.SIGNATURE
          );
        } else if (showPage1) {
          doSendEsignPackage(activeProduct.applicationId, (res) => {
            console.log("esign package", res);
            if (res.data.inReview || res.data.uploadedAt) {
              continuehandler("", AppConstants.APPLICATIONSTEP.SIGNATURE);
            } else {
              products[0].contract = res.data;
              doUpdateProductToVault(products);
              res.data.forEach((contract) => {
                console.log("contract", contract);
                const signer = contract.signers.find(
                  (contractSigner) =>
                    contractSigner.applicantId === activeProduct.applicantId
                );
                if (signer) {
                  console.log("opening tab", signer.url);
                  setTimeout(() => {
                    const a = document.createElement("a");
                    a.setAttribute("href", signer.url);
                    a.setAttribute("target", "_blank");
                    a.click();
                  }, 5000);
                }
              });
              if (isInBranchFlow()) {
                this.setState({ showSmartBranchModal: true });
              } else {
                this.setState({
                  showPage1: false,
                  showPage2: true,
                  showPage3: false,
                });
              }
            }
          });
        } else if (showPage2) {
          // We have sent the package
          doGetEsign(
            {
              applicationId: activeProduct.applicationId,
              sendToStaffEmail: includeESignaturePackage
                ? sessionStorage.getItem(S_STAFF_EMAIL)
                : null,
              esignDocsUploaded:
                activeProduct.esign &&
                Array.isArray(activeProduct.esign) &&
                activeProduct.esign.length > 0,
            },
            (eSignInfo) => {
              console.log(eSignInfo);
              if (eSignInfo.data.length > 0) {
                const incompleteDoc = eSignInfo.data.find(
                  (doc) => !doc.completedAt
                );
                if (incompleteDoc) {
                  this.setState({
                    showPage1: false,
                    showPage2: false,
                    showPage3: true,
                  });
                } else {
                  this.setState({
                    signatureCompleted: true,
                  });
                  doGetApplicationProperty(
                    { applicationId: activeProduct.applicationId },
                    (updateAppProperty) => {
                      console.log("updateAppProperty", updateAppProperty);
                      if (updateAppProperty.inReview) {
                        continuehandler(
                          { showInReview: true },
                          AppConstants.APPLICATIONSTEP.SIGNATURE
                        );
                      } else {
                        if (activeProduct.productType === "Loan") {
                          this.setState({
                            showModal: true,
                            modalType: AppConstants.MODALTYPE.SUCCESS,
                            modal: {
                              title: MODALMESSAGES.SIGNATURE.SUCCESS_TITLE.split(
                                AppConstants.TEMPLATE.NAME
                              ).join(applicantData.member.name),
                              description:
                                MODALMESSAGES.SIGNATURE.LOS_CONGRATS_MESSAGE,
                              description2: bankingTypeSwitch
                                ? MODALMESSAGES.SIGNATURE.BUSINESS_MESSAGE
                                : null,
                            },
                          });
                        } else {
                          this.setState({
                            showModal: true,
                            modalType: AppConstants.MODALTYPE.SUCCESS,
                            modal: {
                              title: MODALMESSAGES.SIGNATURE.SUCCESS_TITLE.split(
                                AppConstants.TEMPLATE.NAME
                              ).join(applicantData.member.name),
                              description:
                                MODALMESSAGES.SIGNATURE.AOS_CONGRATS_MESSAGE,
                              description2: bankingTypeSwitch
                                ? MODALMESSAGES.SIGNATURE.BUSINESS_MESSAGE
                                : null,
                            },
                          });
                        }
                        sessionStorage.removeItem(S_BANKING_TYPE_SWITCH);
                      }
                    }
                  );
                }
              } else {
                this.setState({
                  showPage1: false,
                  showPage2: false,
                  showPage3: true,
                });
              }
            }
          );
        } else if (showPage3) {
          doGetEsign(
            { applicationId: activeProduct.applicationId },
            (eSignInfo) => {
              console.log(eSignInfo);
              if (eSignInfo.data.length > 0) {
                const incompleteDoc = eSignInfo.data.find(
                  (doc) => !doc.completedAt
                );
                if (incompleteDoc) {
                  this.setState({
                    showPage1: false,
                    showPage2: false,
                    showPage3: true,
                  });
                } else {
                  this.setState({
                    signatureCompleted: true,
                  });
                  doGetApplicationProperty(
                    { applicationId: activeProduct.applicationId },
                    (updateAppProperty) => {
                      console.log("updateAppProperty", updateAppProperty);
                      if (updateAppProperty.inReview) {
                        continuehandler(
                          { showInReview: true },
                          AppConstants.APPLICATIONSTEP.SIGNATURE
                        );
                      } else {
                        if (activeProduct.productType === "Loan") {
                          this.setState({
                            showModal: true,
                            modalType: AppConstants.MODALTYPE.SUCCESS,
                            modal: {
                              title: MODALMESSAGES.DISBURSEMENT.CONGRATS_TITLE.split(
                                AppConstants.TEMPLATE.NAME
                              ).join(applicantData.member.name),
                              description: MODALMESSAGES.DISBURSEMENT.CONGRATS_MESSAGE.split(
                                AppConstants.TEMPLATE.NAME
                              ).join(applicantData.member.name),
                              description2: bankingTypeSwitch
                                ? MODALMESSAGES.SIGNATURE.BUSINESS_MESSAGE
                                : null,
                            },
                          });
                        } else {
                          this.setState({
                            showModal: true,
                            modalType: AppConstants.MODALTYPE.SUCCESS,
                            modal: {
                              title: MODALMESSAGES.SIGNATURE.SUCCESS_TITLE.split(
                                AppConstants.TEMPLATE.NAME
                              ).join(applicantData.member.name),
                              description: MODALMESSAGES.SIGNATURE.SUCCESS_MSG.split(
                                AppConstants.TEMPLATE.NAME
                              ).join(applicantData.member.name),
                              description2: bankingTypeSwitch
                                ? MODALMESSAGES.SIGNATURE.BUSINESS_MESSAGE
                                : null,
                            },
                          });
                        }
                        sessionStorage.removeItem(S_BANKING_TYPE_SWITCH);
                      }
                    }
                  );
                }
              } else {
                this.setState({
                  showPage1: false,
                  showPage2: false,
                  showPage3: true,
                });
              }
            }
          );
        }
      }
    );
  };

  deleteDocument = (docIndex) => {
    const {
      getActiveProduct,
      products,
      doDeleteDocument,
      doUpdateProductToVault,
      history,
    } = this.props;
    let activeProduct = getActiveProduct(products);
    const documentId = activeProduct.esign[docIndex].documentId;

    doDeleteDocument(activeProduct.applicationId, documentId, (res) => {
      console.log(res);
      console.log(this.state.documentList);
      activeProduct.esign.splice(docIndex, 1);
      products[0] = activeProduct;
      console.log(this.state.documentList);
      doUpdateProductToVault(products, () => {
        console.log("activeProduct.esign", activeProduct.esign);
        this.setState({
          documentList: activeProduct.esign.map((x) => x),
        });
      });
    });
  };

  addDocumentData = (document) => {
    console.log("Add Document");
    const {
      getActiveProduct,
      products,
      doAddDocument,
      doUpdateProductToVault,
    } = this.props;
    let activeProduct = getActiveProduct(products);
    console.log(activeProduct);
    const applicationId = activeProduct.applicationId;
    const productId = activeProduct.doximProductId;
    console.log(document);
    const formData = new FormData();

    formData.append("System", "product");
    formData.append("ApplicationId", applicationId);
    formData.append("ProductId", productId);
    formData.append("ProductType", activeProduct.productType);
    formData.append("DocumentSource", document.documentSource);

    doAddDocument(applicationId, productId, formData, (res) => {
      console.log(res);
      // Check if the response contains an error
      if (res && res.error) {
        // Call the error callback passed from Signature component
        if (document.onError) {
          document.onError(document.documentId);
        }
        return;
      }

      if (Array.isArray(activeProduct.esign)) {
        activeProduct.esign.push({
          documentId: res.data.docId,
          documentName: document.documentName,
        });
      } else {
        activeProduct.esign = [
          {
            documentId: res.data.docId,
            documentName: document.documentName,
          },
        ];
      }
      products[0] = activeProduct;
      console.log(this.state.documentList);
      doUpdateProductToVault(products, (res) => {
        console.log(res);
        this.setState({
          documentList: activeProduct.esign.map((x) => x),
        });
      });
    });
  };

  render() {
    const {
      modalType,
      modal,
      showModal,
      showPage1,
      showPage2,
      showPage3,
      choice,
      activeProduct,
      showSmartBranchModal,
      includeESignaturePackage,
    } = this.state;
    const { getDataFromServer, handleBack, steps, activeStepID } = this.props;

    return (
      <>
        <Signature
          type={modalType}
          modal={modal}
          showModal={showModal}
          toggleModal={this.toggleModal}
          handlePopupModalBtnClick={this.handlePopupModalBtnClick}
          handleContinue={this.handleContinue}
          getDataFromServer={getDataFromServer}
          handleBack={handleBack}
          choice={choice}
          steps={steps}
          activeStepID={activeStepID}
          showPage1={showPage1}
          showPage2={showPage2}
          showPage3={showPage3}
          activeProduct={activeProduct}
          addDocumentData={this.addDocumentData}
          deleteDocument={this.deleteDocument}
          goToPage2={this.goToPage2}
        />
        {showSmartBranchModal && (
          <Modal
            show={showSmartBranchModal}
            onHide={this.handleSmartBranchClose}
            className="smart-branch-esign-modal"
            aria-labelledby="smart-branch-esign-modal-title"
            aria-describedby="smart-branch-esign-modal-description"
            centered
            backdrop="static"
            keyboard={false}
            size="lg"
            role="dialog"
            aria-modal="true"
          >
            {/* ===================== */}
            {/* HEADER / STATUS ICON */}
            {/* ===================== */}
            <Modal.Header
              className="smart-branch-esign-modal__header"
              style={{
                backgroundColor: "#4CAF50",
                color: "white",
                textAlign: "center",
                border: "none",
              }}
            >
              <div
                className="smart-branch-esign-modal__icon"
                style={{ width: "100%", textAlign: "center" }}
                aria-hidden="true"
              >
                <i
                  className="fas fa-check-circle"
                  style={{ fontSize: "48px", color: "white" }}
                />
              </div>
            </Modal.Header>

            {/* ===================== */}
            {/* BODY */}
            {/* ===================== */}
            <Modal.Body
              className="smart-branch-esign-modal__body"
              style={{ padding: "30px" }}
            >
              <div
                className="smart-branch-esign-modal__content"
                role="status"
                aria-live="polite"
              >
                <h4
                  id="smart-branch-esign-modal-title"
                  className="smart-branch-esign-modal__title"
                  style={{
                    fontWeight: "bold",
                    marginBottom: "20px",
                    color: "#333",
                  }}
                >
                  {STRINGS.BRANCH.SIGNATURE.E_CONTRACTS_MODAL.TITLE_ALT}
                </h4>

                <div id="smart-branch-esign-modal-description">
                  <p>
                    {
                      STRINGS.BRANCH.SIGNATURE.E_CONTRACTS_MODAL
                        .DESCRIPTION_1_ALT
                    }
                  </p>

                  <p>
                    {
                      STRINGS.BRANCH.SIGNATURE.E_CONTRACTS_MODAL
                        .DESCRIPTION_2_ALT
                    }
                  </p>

                  <p>
                    {
                      STRINGS.BRANCH.SIGNATURE.E_CONTRACTS_MODAL
                        .DESCRIPTION_3_ALT
                    }
                  </p>

                  <p>
                    {
                      STRINGS.BRANCH.SIGNATURE.E_CONTRACTS_MODAL
                        .DESCRIPTION_4_ALT
                    }
                  </p>
                </div>

                {/* ===================== */}
                {/* CHECKBOX */}
                {/* ===================== */}
                <div
                  className="smart-branch-esign-modal__checkbox-container"
                  style={{ marginTop: "24px" }}
                >
                  <div>
                    <input
                      id="esignature-checkbox"
                      type="checkbox"
                      checked={includeESignaturePackage}
                      onChange={this.handleSmartBranchCheckboxChange}
                      className="smart-branch-esign-modal__checkbox"
                    />
                    <label
                      htmlFor="esignature-checkbox"
                      className="smart-branch-esign-modal__checkbox-label"
                      style={{ marginLeft: "10px" }}
                    >
                      {
                        STRINGS.BRANCH.SIGNATURE.E_CONTRACTS_MODAL
                          .CHECKBOX_LABEL_ALT
                      }
                    </label>
                  </div>
                </div>
              </div>
            </Modal.Body>

            {/* ===================== */}
            {/* FOOTER */}
            {/* ===================== */}
            <Modal.Footer
              className="smart-branch-esign-modal__footer"
              style={{
                textAlign: "center",
                border: "none",
                paddingTop: "0",
                justifyContent: "center",
              }}
            >
              <button
                type="button"
                className="btn smart-branch-esign-modal__continue-btn"
                onClick={this.handleSmartBranchContinue}
                autoFocus
                style={{
                  backgroundColor: "#2196F3",
                  color: "white",
                  border: "none",
                  padding: "12px 40px",
                  fontSize: "16px",
                  fontWeight: "bold",
                  borderRadius: "4px",
                  minWidth: "150px",
                }}
              >
                {STRINGS.BRANCH.SIGNATURE.E_CONTRACTS_MODAL.CONTINUE_BTN_ALT}
              </button>
            </Modal.Footer>
          </Modal>
        )}
      </>
    );
  }
}

SignatureContainer.propTypes = {
  getDataFromServer: PropTypes.func.isRequired,
  history: PropTypes.oneOfType([PropTypes.object]),
  continuehandler: PropTypes.func.isRequired,
  handleBack: PropTypes.func.isRequired,
  doGetProductFromVault: PropTypes.func.isRequired,
  products: PropTypes.arrayOf(PropTypes.object),
  steps: PropTypes.arrayOf(PropTypes.object),
  activeStepID: PropTypes.number,
  getActiveProduct: PropTypes.func.isRequired,
  applicationList: PropTypes.arrayOf(PropTypes.any).isRequired,
  doGetApplicationList: PropTypes.func.isRequired,
  doCreateEsignDoc: PropTypes.func.isRequired,
  doGetEsign: PropTypes.func.isRequired,
  doUpdateProductToVault: PropTypes.func.isRequired,
  doGetApplicationProperty: PropTypes.func.isRequired,
};

SignatureContainer.defaultProps = {
  history: null,
  products: [],
  steps: [],
  activeStepID: -1,
};

const mapStateToProps = (state) => ({
  MemberExists: state.MemberExistsReducer,
  products: state.VaultReducer.vaultProductList,
  applicationList: state.ApplicationReducer.applicationList,
  inReview: state.ApplicationReducer.inReview,
  uploadedAt: state.ApplicationReducer.uploadedAt,
  applicantData: state.ApplicationReducer.response,
});

const mapDispatchToProps = (dispatch) => {
  return {
    doGetAcoountDetails: (callback) => dispatch(getAccount(callback)),
    doCreateInverite: (callback) => dispatch(callCreateInverite(callback)),
    doGetProductFromVault: (callback) =>
      dispatch(getProductFromVault(callback)),
    doGetApplicationList: (callback) => dispatch(getApplicationList(callback)),
    doCreateEsignDoc: (applicationId, callback) =>
      dispatch(createEsignDoc(applicationId, callback)),
    doSendEsignPackage: (applicationId, callback) =>
      dispatch(sendEsignPackage(applicationId, callback)),
    doGetEsign: (esignParam, callback) =>
      dispatch(getEsign(esignParam, callback)),
    doUpdateProductToVault: (vaultProductList, callback) =>
      dispatch(updateProductToVault(vaultProductList, callback)),
    doGetApplicationProperty: (request, callback) =>
      dispatch(getApplicationProperty(request, callback)),
    doAddDocument: (applicationId, productId, payload, callback) =>
      dispatch(addDocument(applicationId, productId, payload, callback)),
    doDeleteDocument: (applicationId, documentId, callback) =>
      dispatch(deleteDocument(applicationId, documentId, callback)),
    doGetDocumentList: (applicationId, productId, callback) =>
      dispatch(getDocumentList(applicationId, productId, callback)),
  };
};

const SignatureWrapper = withApplicantHOC(SignatureContainer);

export default connect(mapStateToProps, mapDispatchToProps)(SignatureWrapper);
